import { BooleanValue, Schema } from '@coveo/bueno';
import { searchBoxOptionDefinitions as coreSearchBoxOptionDefinitions, } from '../../core/search-box/headless-core-search-box-options.js';
export const defaultSearchBoxOptions = {
    clearFilters: true,
    enableResults: false,
};
const { id, highlightOptions, clearFilters } = coreSearchBoxOptionDefinitions;
export const searchBoxOptionDefinitions = {
    id,
    highlightOptions,
    clearFilters,
    enableResults: new BooleanValue(),
};
export const searchBoxOptionsSchema = new Schema(searchBoxOptionDefinitions);
